// Restaurant — Olive Flame
export const restaurant = {
  name: "Olive Flame",
  tagline: "Wood fired Mediterranean. Crafted nightly.",
  hero:
    "https://images.unsplash.com/photo-1692197277937-c8d62dc93f18?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  about:
    "Olive Flame is a wood fired Mediterranean kitchen rooted in slow cooking, market produce and a respect for fire. Our team cooks every night with seasonal ingredients and a small, perfected menu.",
  menu: [
    {
      category: "Starters",
      items: [
        { name: "Charred Eggplant Mezze", desc: "Smoked eggplant, tahini, pomegranate.", price: 32 },
        { name: "Burrata & Heirloom", desc: "Buffalo burrata, heirloom tomatoes, basil oil.", price: 44 },
        { name: "Saffron Hummus", desc: "Chickpea, saffron, warm flatbread.", price: 29 },
        { name: "Crispy Calamari", desc: "Lemon aioli, herbs, charred lemon.", price: 38 },
        { name: "Labneh & Olive Oil", desc: "Za'atar, cucumber, grilled pita.", price: 26 },
      ],
    },
    {
      category: "Mains",
      items: [
        { name: "Wood Fired Lamb", desc: "Slow roasted lamb, smoked yogurt, herbs.", price: 102 },
        { name: "Olive Flame Steak", desc: "Aged ribeye, charred shallot, bone marrow butter.", price: 126 },
        { name: "Saffron Risotto", desc: "Carnaroli rice, saffron, parmigiano, lemon zest.", price: 82 },
        { name: "Sea Bass al Sale", desc: "Whole sea bass baked in salt crust.", price: 108 },
        { name: "Chicken Shawarma Tagine", desc: "Preserved lemon, root vegetables, herbs.", price: 86 },
        { name: "Truffle Mushroom Gnocchi", desc: "Brown butter, pecorino, thyme.", price: 74 },
      ],
    },
    {
      category: "Desserts",
      items: [
        { name: "Olive Oil Cake", desc: "Citrus, sea salt, mascarpone.", price: 34 },
        { name: "Dark Chocolate Tart", desc: "Smoked salt, espresso cream.", price: 37 },
        { name: "Pistachio Baklava", desc: "Rose syrup, toasted pistachio, citrus zest.", price: 31 },
        { name: "Affogato", desc: "Vanilla gelato, espresso, cocoa nibs.", price: 22 },
      ],
    },
  ],
  reviews: [
    {
      name: "Layla H.",
      quote:
        "Best lamb I've had in years. The dining room feels like a candlelit cellar — in the best way.",
      stars: 5,
    },
    {
      name: "Marco D.",
      quote:
        "Service is sharp and the wine list is properly thought through. We come back monthly.",
      stars: 5,
    },
    {
      name: "Sara K.",
      quote: "The wood fired flavor is the real deal. Everything tastes intentional.",
      stars: 5,
    },
  ],
  hours: [
    { day: "Mon – Thu", time: "5:30 PM – 11:00 PM" },
    { day: "Fri – Sat", time: "5:30 PM – 12:30 AM" },
    { day: "Sunday", time: "5:00 PM – 10:30 PM" },
  ],
  address: "14 Old Harbor Lane, Old Town",
  phone: "+970 56 826 4676",
};

// Café — Velvet Cup
export const cafe = {
  name: "Velvet Cup",
  tagline: "Slow coffee. Soft afternoons.",
  hero:
    "https://images.unsplash.com/photo-1764395025770-81edf84d57b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  about:
    "Velvet Cup is a neighbourhood café for people who treat coffee as a small ceremony. Specialty single origins, hand baked pastries, and a room designed for staying a while.",
  coffee: [
    { name: "Velvet Latte", desc: "House espresso, vanilla bean, oat milk.", price: 21 },
    { name: "Rose Cortado", desc: "Double shot, rose syrup, whole milk.", price: 19 },
    { name: "Ethiopian Pour Over", desc: "Yirgacheffe, jasmine, citrus notes.", price: 23 },
    { name: "Iced Mocha Velour", desc: "Espresso, dark chocolate, cream foam.", price: 24 },
    { name: "Saffron Cappuccino", desc: "Espresso, saffron infused milk.", price: 22 },
    { name: "Maple Flat White", desc: "Silky milk, double espresso, maple dust.", price: 21 },
  ],
  desserts: [
    { name: "Pistachio Croissant", desc: "Hand-laminated, pistachio cream.", price: 19 },
    { name: "Velvet Cheesecake", desc: "Berry compote, biscuit base.", price: 24 },
    { name: "Cardamom Babka", desc: "Brown butter, cardamom sugar.", price: 21 },
    { name: "Tiramisu Cup", desc: "Espresso-soaked, mascarpone cloud.", price: 24 },
    { name: "Chocolate Chunk Cookie", desc: "Sea salt, dark chocolate, soft center.", price: 14 },
    { name: "Lemon Olive Loaf", desc: "Citrus glaze, olive oil crumb.", price: 16 },
  ],
  offers: [
    { title: "Morning Set", body: "Any espresso drink + pastry, weekdays before 10am.", price: "₪29" },
    { title: "Afternoon Slow Down", body: "Pour over + dessert, 3pm to 6pm.", price: "₪37" },
    { title: "Loyalty: 9th Drink Free", body: "Every 9th drink is on us. No app required." },
  ],
  gallery: [
    "https://images.unsplash.com/photo-1442512595331-e89e73853f31?w=800&q=80",
    "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=800&q=80",
    "https://images.unsplash.com/photo-1453614512568-c4024d13c247?w=800&q=80",
    "https://images.unsplash.com/photo-1521017432531-fbd92d768814?w=800&q=80",
    "https://images.unsplash.com/photo-1559496417-e7f25cb247f3?w=800&q=80",
    "https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=800&q=80",
  ],
  hours: [
    { day: "Mon – Fri", time: "7:00 AM – 8:00 PM" },
    { day: "Sat – Sun", time: "8:00 AM – 9:00 PM" },
  ],
  address: "27 Linden Street, Riverside",
  phone: "+970 56 826 4676",
};

// Clinic — CarePoint
export const clinic = {
  name: "CarePoint Clinic",
  tagline: "Modern primary care, on your schedule.",
  hero: "/hero%20clinc.png",
  about:
    "CarePoint Clinic offers attentive primary, family, and preventive care. Same week appointments, transparent pricing, and clinicians who actually listen.",
  services: [
    { name: "Family Medicine", desc: "Primary care for kids, adults, and seniors." },
    { name: "Preventive Health", desc: "Check-ups, screenings, lifestyle plans." },
    { name: "Chronic Care", desc: "Diabetes, hypertension, thyroid, asthma." },
    { name: "Pediatrics", desc: "Wellness visits, immunizations, sick care." },
    { name: "Women's Health", desc: "Routine care, hormonal health, screenings." },
    { name: "Lab & Diagnostics", desc: "On-site bloodwork, ECG, rapid testing." },
  ],
  doctors: [
    {
      name: "Dr. Hana Saleh",
      role: "Family Medicine",
      img: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=600&q=80",
      bio: "12 years in primary care. Special focus on preventive medicine.",
    },
    {
      name: "Dr. Omar Khalid",
      role: "Internal Medicine",
      img: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=600&q=80",
      bio: "Internal medicine and chronic disease management.",
    },
    {
      name: "Dr. Mira Younes",
      role: "Pediatrics",
      img: "https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=600&q=80",
      bio: "Pediatrician — 9 years caring for kids of all ages.",
    },
    {
      name: "Dr. Adel Rahimi",
      role: "Women's Health",
      img: "https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=600&q=80",
      bio: "Women's health, screenings, and hormonal care.",
    },
  ],
  testimonials: [
    {
      name: "Noor A.",
      quote:
        "Booked online, in and out in 25 minutes, real follow-up the next day. This is what care should feel like.",
    },
    {
      name: "Tariq M.",
      quote:
        "Dr. Hana actually explained everything. First time I felt heard at a clinic in years.",
    },
    {
      name: "Sami R.",
      quote: "Clean, calm, and modern. The kids weren't scared — first time ever.",
    },
  ],
  hours: [
    { day: "Mon – Fri", time: "8:00 AM – 7:00 PM" },
    { day: "Saturday", time: "9:00 AM – 2:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
  address: "210 Northbridge Ave, Suite 4",
  phone: "+970 56 826 4676",
};

const asset = (name) => encodeURI(`${process.env.PUBLIC_URL}/${name}`);

// Café — Palo Café (Full Café System)
export const paloCafe = {
  name: "Palo Café",
  tagline: "Premium coffee moments, crafted for you",
  hero: asset("background palo cafe.jpg"),
  about:
    "Palo Café is a full café system for modern coffee shops, combining beautiful ordering, loyalty rewards, barista task management, and live business insights in one polished experience.",
  story: "Founded with a passion for bringing café culture to everyone, Palo Café started as a small dream and has grown into a beloved community spot. We believe in quality over quantity, sustainability over trends, and creating spaces where people genuinely connect. Every bean is sourced ethically, every barista is trained meticulously. The space is designed for slow mornings, quick meetings, and repeat visits that feel personal every time.",
  testimonials: [
    {
      name: "Layla Hassan",
      role: "Regular Customer",
      quote: "The best cappuccino in the city. The baristas actually know my name and remember my order.",
      stars: 5,
    },
    {
      name: "Omar Khalil",
      role: "Morning Regular",
      quote: "I start every morning here. The atmosphere is warm, the coffee is perfect, and the team is always smiling.",
      stars: 5,
    },
    {
      name: "Noor Jamila",
      role: "Coffee Enthusiast",
      quote: "Finally, a café that takes coffee seriously. The single-origin options are exceptional.",
      stars: 5,
    },
  ],
  specialties: [
    {
      name: "Signature Cappuccino",
      desc: "Our most-loved drink with perfectly steamed milk",
      img: asset("cappuccino.jpg"),
    },
    {
      name: "Flat White",
      desc: "Silky microfoam and a clean espresso finish",
      img: asset("flat white.jpg"),
    },
    {
      name: "Iced Latte",
      desc: "Silky espresso with a cool, clean finish",
      img: asset("iced latte.jpg"),
    },
  ],
  gallery: [
    asset("random coffee.jpg"),
    asset("white mocha.jpg"),
    asset("turkish coffee.jpg"),
  ],
  loyaltyInfo: {
    title: "Palo Loyalty Card",
    description: "Collect points with every order and enjoy exclusive rewards",
    benefits: [
      "1 point per order",
      "Free drink after 10 points",
      "Birthday surprises",
      "Early access to new drinks",
      "Exclusive member discounts",
    ],
  },
  menu: [
    {
      category: "Hot Drinks",
      icon: "Coffee",
      items: [
        { name: "Espresso", desc: "Bold and rich double shot", origin: "Brazilian Santos", price: 8, id: "hd1", img: asset("espresso.jpg"), popular: true, roast: "Dark" },
        { name: "Americano", desc: "Espresso with hot water", origin: "Argentinian Blend", price: 9, id: "hd2", img: asset("americano.jpg"), roast: "Medium" },
        { name: "Cappuccino", desc: "Espresso, steamed milk, foam", origin: "Italian Classic", price: 12, id: "hd3", img: asset("cappuccino.jpg"), popular: true, bestseller: true, roast: "Medium" },
        { name: "Latte", desc: "Smooth espresso with silky milk", origin: "Colombian Geisha", price: 12, id: "hd4", img: asset("latte.jpg"), popular: true, roast: "Medium" },
        { name: "Flat White", desc: "Velvety microfoam delight", origin: "Ethiopian Yirgacheffe", price: 13, id: "hd5", img: asset("flat white.jpg"), roast: "Light" },
        { name: "Mocha", desc: "Espresso with chocolate", origin: "Kenyan AA", price: 14, id: "hd6", img: asset("white mocha.jpg"), roast: "Dark" },
        { name: "Cortado", desc: "Equal parts espresso and milk", origin: "Tanzanian Peaberry", price: 10, id: "hd8", img: asset("arabic coffee.jpg"), roast: "Medium" },
      ],
    },
    {
      category: "Iced Drinks",
      icon: "Snowflake",
      items: [
        { name: "Iced Americano", desc: "Cold and crisp", origin: "Argentinian Blend", price: 10, id: "id1", img: asset("iced americano.jpg"), roast: "Medium" },
        { name: "Iced Latte", desc: "Cold espresso with milk", origin: "Colombian Geisha", price: 12, id: "id2", img: asset("iced latte.jpg"), popular: true, roast: "Light" },
        { name: "Iced Caramel Latte", desc: "Sweet caramel with chilled espresso", origin: "Brazilian Santos", price: 13, id: "id3", img: asset("iced carmel.jpg"), roast: "Medium" },
        { name: "Iced Mocha", desc: "Chocolate and coffee bliss", origin: "Kenyan AA", price: 14, id: "id4", img: asset("iced mocha.jpg"), popular: true, roast: "Dark" },
        { name: "Cold Brew", desc: "Smooth 12-hour brew", origin: "House Blend", price: 11, id: "id5", img: asset("iced coffee.jpg"), roast: "Medium" },
        { name: "Iced Spanish Latte", desc: "Sweet and smooth", origin: "Tanzanian Peaberry", price: 13, id: "id6", img: asset("iced spaninsh latte.jpg"), roast: "Light" },
      ],
    },
    {
      category: "Mojitos",
      icon: "Leaf",
      items: [
        { name: "Strawberry Mojito", desc: "Fresh strawberries, mint, lime", price: 16, id: "mj1", img: asset("strawberry mojito.jpg") },
        { name: "Lemon Mint Mojito", desc: "Citrus and fresh mint", price: 15, id: "mj2", img: asset("mojito.jpg") },
        { name: "Berry Mojito", desc: "Bright berry notes with mint", price: 16, id: "mj3", img: asset("seasonal drinks.jpg") },
        { name: "Passion Fruit Mojito", desc: "Tropical passion fruit blend", price: 17, id: "mj4", img: asset("random coffee.jpg") },
      ],
    },
    {
      category: "Smoothies",
      icon: "Droplets",
      items: [
        { name: "Berry Blend", desc: "Mixed berries with yogurt", price: 14, id: "sm1", img: asset("matcha.jpg") },
        { name: "Mango Smoothie", desc: "Tropical mango delight", price: 14, id: "sm2", img: asset("seasonal drinks.jpg") },
        { name: "Strawberry Banana", desc: "Classic combination", price: 13, id: "sm3", img: asset("random coffee.jpg") },
        { name: "Green Smoothie", desc: "Healthy spinach blend", price: 15, id: "sm4", img: asset("iced matcha.jpg") },
      ],
    },
    {
      category: "Pastries & Bakery",
      icon: "Cake",
      items: [
        { name: "Croissant", desc: "Buttery and flaky", price: 7, id: "pb1", img: asset("croissants.jpg") },
        { name: "Blueberry Muffin", desc: "Fresh blueberries inside", price: 8, id: "pb2", img: asset("muffins.jpg") },
        { name: "Chocolate Brownie", desc: "Rich and fudgy", price: 8, id: "pb3", img: asset("cheesecake.jpg") },
        { name: "Cheesecake", desc: "Creamy with berry topping", price: 11, id: "pb4", img: asset("pastries.jpg") },
        { name: "Cinnamon Roll", desc: "Sweet and swirly", price: 9, id: "pb5", img: asset("cinaboon.jpg") },
      ],
    },
  ],
  sampleOrders: [
    {
      id: "ORD-001",
      name: "Sara Al-Mansouri",
      items: [
        { name: "Cappuccino", qty: 1, price: 12 },
        { name: "Croissant", qty: 1, price: 7 },
      ],
      notes: "Extra hot, less foam",
      table: "3",
      total: 19,
      status: "Pending",
      time: "2:34 PM",
    },
    {
      id: "ORD-002",
      name: "Ahmed Khalil",
      items: [
        { name: "Cold Brew", qty: 2, price: 11 },
        { name: "Chocolate Brownie", qty: 1, price: 8 },
      ],
      notes: "Extra ice",
      table: "Pickup",
      total: 30,
      status: "Preparing",
      time: "2:28 PM",
    },
    {
      id: "ORD-003",
      name: "Noor Jamila",
      items: [
        { name: "Iced Vanilla Latte", qty: 1, price: 13 },
        { name: "Blueberry Muffin", qty: 1, price: 8 },
      ],
      notes: "",
      table: "7",
      total: 21,
      status: "Ready",
      time: "2:15 PM",
    },
  ],
  baristaTasks: [
    { id: 1, task: "Restock espresso beans", priority: "High", time: "10:30 AM" },
    { id: 2, task: "Clean milk frother", priority: "Medium", time: "11:00 AM" },
    { id: 3, task: "Prep pastries for afternoon rush", priority: "High", time: "2:00 PM" },
    { id: 4, task: "Check ice machine", priority: "Low", time: "3:00 PM" },
  ],
  analytics: {
    totalOrdersToday: 67,
    pendingOrders: 2,
    preparingOrders: 4,
    readyOrders: 3,
    cancelledOrders: 1,
    totalRevenueToday: 845,
    bestSellingItem: "Cappuccino",
    peakHour: "9 AM - 10 AM",
    topDrinks: [
      { name: "Cappuccino", count: 18, revenue: 216 },
      { name: "Latte", count: 15, revenue: 180 },
      { name: "Cold Brew", count: 12, revenue: 132 },
    ],
    avgOrderValue: 12.6,
    insights: [
      "Cappuccino is top performer - consider featured promotions",
      "Morning rush is 9-10 AM - ensure peak staffing",
      "Cold drinks increasing 30% - add more iced options",
      "Customers adding pastries 45% of the time",
      "Loyalty program driving 35% of repeat orders",
    ],
  },
  promotion: {
    title: "Limited Time",
    description: "Cappuccino + Croissant Combo",
    originalPrice: 19,
    promoPrice: 16,
    discount: "3 NIS OFF",
    badge: "Morning Special",
  },
  hours: [
    { day: "Mon – Fri", time: "7:00 AM – 9:00 PM" },
    { day: "Sat – Sun", time: "8:00 AM – 10:00 PM" },
  ],
  address: "Downtown Coffee District",
  phone: "+970 56 826 4676",
};

export const demosList = [
  {
    slug: "restaurant",
    title: "Olive Flame",
    type: "Restaurant",
    description: "Wood fired Mediterranean kitchen with online ordering and reservations.",
    cover:
      "https://images.unsplash.com/photo-1692197277937-c8d62dc93f18?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    accent: "#FF7A1A",
    path: "/demo/restaurant",
  },
  {
    slug: "palo",
    title: "Palo Café System",
    type: "Café",
    description: "Full café system with ordering, loyalty rewards, admin controls, barista tasks, and live analytics.",
    cover:
      asset("background palo cafe.jpg"),
    accent: "#A0672F",
    path: "/demo/palo",
  },
  {
    slug: "cafe",
    title: "Velvet Cup",
    type: "Café",
    description: "Specialty café with loyalty program, ordering, and warm storytelling.",
    cover:
      "https://images.unsplash.com/photo-1764395025770-81edf84d57b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    accent: "#D8B4E2",
    path: "/demo/cafe",
  },
  {
    slug: "clinic",
    title: "CarePoint Clinic",
    type: "Clinic",
    description: "Trustworthy primary care site with online appointment booking.",
    cover:
      "https://images.unsplash.com/photo-1631507623095-c710d184498f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    accent: "#1A6FE8",
    path: "/demo/clinic",
  },
];
